module.exports = "<div class=\"footer_links\">\n    <p><a href=\"https://www.nbcuniversal.com/privacy\" target=\"_blank\">NBCU Privacy Policy</a></p>    \n    <p><a href=\"https://www.chasepaymentech.com/privacypolicy\" target=\"_blank\">Chase Privacy Policy</a></p>         \n    <p><a href=\"../../assets/MediaPay_Terms.pdf\" target=\"_blank\">Terms of Service</a></p>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = main